
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { mapIndexed, length, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { useTranslation } from "react-i18next";
import { useDrag } from "../../Bindings/Fable.ReactDnD.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { elementTypeTranslationKey, dragStepFromElementType, dragStepTestId } from "./Helper.js";
import Hamburger_Menu_1 from "../../../public/assets/icons/Hamburger_Menu_1.svg";
import { unwrap, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { PhotoCapture_defaultMaxCount, PhotoCapture_defaultMinCount } from "../../Shared/Procedure.js";
import { Msg, DragStep } from "./Types.js";
import { Badge } from "../../Components/Badge.js";
import { Input } from "../../Components/Input.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { TextArea } from "../../Components/TextArea.js";

export function ElementTypeIcon(props) {
    let elems_1;
    return reactElement("span", createObj(ofArray([["className", join(" ", ["flex", "shrink-0", "items-center", "justify-center", "w-7", "h-7", "rounded", "bg-primary/15", "text-[#0B7A65]"])], (elems_1 = [reactElement("span", {
        className: join(" ", ["h-4", "w-4"]),
        children: reactApi.Children.toArray([props.Icon]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function DragStepComponent(props) {
    const patternInput = useTranslation();
    const patternInput_1 = useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => props.DragStep,
        type: "STEP_ELEMENT",
    });
    const isDisabled = props.ComponentState === "disabled";
    return reactElement("div", createObj(toList(delay(() => append(!isDisabled ? singleton(["ref", patternInput_1[1]]) : empty(), delay(() => append(singleton(["role", join(" ", ["button"])]), delay(() => append(singleton(["tabIndex", isDisabled ? -1 : 0]), delay(() => append(singleton(["aria-disabled", isDisabled]), delay(() => append(singleton(["data-test-id", concat("procedure-palette-", ...dragStepTestId(props.DragStep.Type))]), delay(() => append(singleton(["onClick", (_arg_1) => {
        if (!isDisabled) {
            props.OnClick();
        }
    }]), delay(() => append(singleton(["onKeyDown", (event) => {
        if (!isDisabled && ((event.key === "Enter") ? true : (event.key === " "))) {
            event.preventDefault();
            props.OnClick();
        }
    }]), delay(() => append(singleton(["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("w-full"), delay(() => append(singleton("h-10"), delay(() => append(singleton("items-center"), delay(() => append(singleton("gap-2.5"), delay(() => append(singleton("px-2"), delay(() => append(singleton("mb-1"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("border"), delay(() => append(singleton("border-border"), delay(() => append(singleton("rounded"), delay(() => append(singleton("text-sm"), delay(() => append(singleton("text-left"), delay(() => append(singleton("hover:border-primary"), delay(() => append(singleton("focus:outline-none"), delay(() => append(singleton("focus-visible:border-primary"), delay(() => (isDisabled ? append(singleton("cursor-not-allowed"), delay(() => singleton("text-text-muted"))) : singleton("cursor-grab")))))))))))))))))))))))))))))))))))))]), delay(() => {
        let elems_1, elems;
        return singleton((elems_1 = [createElement(ElementTypeIcon, {
            Icon: props.DragStep.Icon,
        }), reactElement("span", {
            className: join(" ", ["grow"]),
            children: patternInput[0](props.DragStep.TranslationKey),
        }), reactElement("span", createObj(ofArray([["className", join(" ", ["h-4", "w-4", "text-darkgrey"])], (elems = [Hamburger_Menu_1()], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]));
    }))))))))))))))))))));
}

function elementChips(t, i18n, stepElement) {
    return toList(delay(() => append(stepElement.Required ? singleton(t("general.required")) : empty(), delay(() => {
        let arg_1, arg_3, arg_5, min;
        const matchValue = stepElement.Type;
        switch (matchValue.tag) {
            case 9:
            case 10:
            case 11:
                return singleton((arg_1 = {
                    count: length(stepElement.Options),
                }, i18n.t("procedure.form.options_count", arg_1)));
            case 12:
                return singleton((arg_3 = {
                    count: length(stepElement.Options),
                }, i18n.t("procedure.form.images_count", arg_3)));
            case 13:
                return singleton((arg_5 = ((min = (defaultArg(stepElement.MinCount, PhotoCapture_defaultMinCount) | 0), {
                    max: defaultArg(stepElement.MaxCount, PhotoCapture_defaultMaxCount),
                    min: min,
                })), i18n.t("procedure.form.photo_count", arg_5)));
            default: {
                return empty();
            }
        }
    }))));
}

export function StepElement(props) {
    let elems_3;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const baseDragStep = dragStepFromElementType(props.StepElement.Type);
    const patternInput_1 = useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => (new DragStep(baseDragStep.Id, baseDragStep.TranslationKey, baseDragStep.AssignedId, {
            StepElementPosition: props.StepElement.Position,
            StepPosition: props.StepPosition,
        }, baseDragStep.Type, baseDragStep.Icon)),
        type: "STEP_ELEMENT",
    });
    const label = (props.StepElement.Label.trim() === "") ? t("procedure.form.unnamed_element") : props.StepElement.Label;
    return reactElement("div", createObj(ofArray([["ref", patternInput_1[2]], ["data-test-id", `procedure-step-element-${props.StepPosition}-${props.StepElement.Position}`], ["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("gap-3"), delay(() => append(singleton("px-3"), delay(() => append(singleton("py-2.5"), delay(() => append(singleton("rounded"), delay(() => append(singleton("cursor-pointer"), delay(() => (props.IsSelected ? append(singleton("border-2"), delay(() => append(singleton("border-primary"), delay(() => singleton("bg-primary/5"))))) : append(singleton("border"), delay(() => append(singleton("border-border"), delay(() => singleton("bg-white")))))))))))))))))))))))], ["onClick", (e) => {
        e.stopPropagation();
        props.Dispatch(new Msg(10, [props.StepPosition, props.StepElement.Position]));
    }], (elems_3 = toList(delay(() => {
        let elems;
        return append(props.IsEditable ? singleton(reactElement("div", createObj(ofArray([["ref", patternInput_1[1]], ["className", join(" ", ["h-4", "w-4", "shrink-0", "cursor-grab", "text-darkgrey"])], (elems = [Hamburger_Menu_1()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => append(singleton(createElement(ElementTypeIcon, {
            Icon: baseDragStep.Icon,
        })), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "min-w-0"])], (elems_1 = [reactElement("div", {
                className: join(" ", ["text-xs", "text-black"]),
                children: t(elementTypeTranslationKey(props.StepElement.Type)),
            }), reactElement("div", {
                className: join(" ", toList(delay(() => append(singleton("text-sm"), delay(() => append(singleton("font-bold"), delay(() => append(singleton("truncate"), delay(() => ((props.StepElement.Label.trim() === "") ? singleton("text-text-muted") : empty())))))))))),
                children: label,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "shrink-0"])], (elems_2 = mapIndexed((index, chip) => createElement(Badge, {
                    Color: "#E1E7F0",
                    Label: chip,
                    TestId: `procedure-step-element-${props.StepPosition}-${props.StepElement.Position}-chip-${index}`,
                }), elementChips(t, patternInput[1], props.StepElement)), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function SidebarComponentStep(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems = [createElement(Input, {
        ComponentState: props.ComponentState,
        Label: t("general.name"),
        OnChange: (value_1) => {
            props.Dispatch(new Msg(8, [props.Position, value_1]));
        },
        TestId: "procedure-template-step-name-input",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-name`)),
        Value: props.ProcedureTemplateStep.Name,
    }), createElement(TextArea, {
        ComponentState: props.ComponentState,
        Label: t("general.description"),
        OnChange: (value_2) => {
            props.Dispatch(new Msg(9, [props.Position, value_2]));
        },
        TestId: "procedure-template-step-description-input",
        Value: props.ProcedureTemplateStep.Description,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

